"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrosoftLogin = void 0;
var MicrosoftLogin_1 = __importDefault(require("./MicrosoftLogin"));
exports.MicrosoftLogin = MicrosoftLogin_1.default;
exports.default = MicrosoftLogin_1.default;
//# sourceMappingURL=index.js.map